import { render, staticRenderFns } from "./Orderlist.vue?vue&type=template&id=383c2b5c&scoped=true&"
import script from "./Orderlist.vue?vue&type=script&lang=js&"
export * from "./Orderlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383c2b5c",
  null
  
)

export default component.exports